
<!--【公共头部-、底部】 -->
<template>
  <div id="pc_layout">
    <GlobalHeaderPC />
    <div class="box60"></div>
    <router-view />
    <GlobalFooterPC />
  </div>
</template>

<script>
import GlobalFooterPC from "./components/pc/GlobalFooter";
import GlobalHeaderPC from "./components/pc/GlobalHeader";
export default {
  components: { GlobalHeaderPC, GlobalFooterPC }
};
</script>

<style>
@import "~@/assets/pc/css/public.scss";
</style>